/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Output_WorkingInputs */

const en_landing_studio_output_working = /** @type {(inputs: Landing_Studio_Output_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The model is working. This usually takes 10 to 40 seconds.`)
};

const zh_landing_studio_output_working = /** @type {(inputs: Landing_Studio_Output_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 正在生成，通常需要 10 到 40 秒。`)
};

/**
* | output |
* | --- |
* | "The model is working. This usually takes 10 to 40 seconds." |
*
* @param {Landing_Studio_Output_WorkingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_output_working = /** @type {((inputs?: Landing_Studio_Output_WorkingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Output_WorkingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_output_working(inputs)
	return zh_landing_studio_output_working(inputs)
});
export { landing_studio_output_working as "landing.studio.output_working" }